export const adminSettingPages = [
  {
    key: "gateway",
    title: "Gateway de pagamento",
    description:
      "Escolha o provedor ativo para o checkout e mantenha separadas as credenciais de teste e produção.",
    fields: [
      {
        name: "activeGateway",
        label: "Gateway ativo",
        type: "select",
        defaultValue: "asaas",
        options: [
          { label: "Asaas", value: "asaas" },
          { label: "Mercado Pago", value: "mercado_pago" },
        ],
      },
      {
        name: "sandbox",
        label: "Usar ambiente de teste",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "asaasEnabled",
        label: "Ativar Asaas",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "asaasApiKey",
        label: "Chave de API do Asaas",
        type: "text",
        inputType: "password",
        placeholder: "a1b2c3...",
        defaultValue: "",
      },
      {
        name: "asaasWebhookSecret",
        label: "Segredo do webhook do Asaas",
        type: "text",
        inputType: "password",
        placeholder: "Webhook secret",
        defaultValue: "",
      },
      {
        name: "mercadoPagoEnabled",
        label: "Ativar Mercado Pago",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "mercadoPagoAccessToken",
        label: "Access token do Mercado Pago",
        type: "text",
        inputType: "password",
        placeholder: "APP_USR-...",
        defaultValue: "",
      },
      {
        name: "mercadoPagoWebhookSecret",
        label: "Segredo do webhook do Mercado Pago",
        type: "text",
        inputType: "password",
        placeholder: "Webhook secret",
        defaultValue: "",
      },
    ],
  },
  {
    key: "email",
    title: "Integração de e-mail",
    description:
      "Use uma API Key criada no MiMail. O MiBoard envia para o endpoint oficial /api/send e mantém a chave protegida no servidor.",
    fields: [
      {
        name: "provider",
        label: "Provedor",
        type: "select",
        defaultValue: "mimail",
        options: [{ label: "Mimail", value: "mimail" }],
      },
      {
        name: "apiBaseUrl",
        label: "URL da API",
        type: "text",
        inputType: "url",
        placeholder: "https://www.mimail.com.br/api/send",
        defaultValue: "https://www.mimail.com.br/api/send",
      },
      {
        name: "apiKey",
        label: "API Key do MiMail",
        type: "text",
        inputType: "password",
        placeholder: "Cole a API Key criada no MiMail",
        defaultValue: "",
      },
      {
        name: "senderName",
        label: "Nome do remetente",
        type: "text",
        placeholder: "MiBoard",
        defaultValue: "MiBoard",
      },
      {
        name: "senderEmail",
        label: "E-mail do remetente",
        type: "text",
        inputType: "email",
        placeholder: "no-reply@exemplo.com",
        defaultValue: "",
      },
      {
        name: "replyTo",
        label: "Reply-to",
        type: "text",
        inputType: "email",
        placeholder: "suporte@exemplo.com",
        defaultValue: "",
      },
    ],
  },
  {
    key: "email_templates",
    title: "Templates de e-mail",
    description:
      "Edite os assuntos e mensagens padrão enviadas pelo sistema aos usuários.",
    fields: [
      {
        name: "signupSubject",
        label: "Assunto de confirmação de cadastro",
        type: "text",
        placeholder: "Confirme sua conta no MiBoard",
        defaultValue: "Confirme sua conta no MiBoard",
      },
      {
        name: "signupBody",
        label: "Corpo de confirmação de cadastro",
        type: "textarea",
        rows: 5,
        placeholder:
          "Olá {{name}}, confirme seu cadastro acessando {{confirmLink}}.",
        defaultValue:
          "Olá {{name}}, confirme seu cadastro acessando {{confirmLink}}.",
      },
      {
        name: "welcomeSubject",
        label: "Assunto de boas-vindas",
        type: "text",
        placeholder: "Bem-vindo ao MiBoard",
        defaultValue: "Bem-vindo ao MiBoard",
      },
      {
        name: "welcomeBody",
        label: "Corpo de boas-vindas",
        type: "textarea",
        rows: 5,
        placeholder: "Olá {{name}}, seu acesso foi criado com sucesso.",
        defaultValue: "Olá {{name}}, seu acesso foi criado com sucesso.",
      },
      {
        name: "resetSubject",
        label: "Assunto de redefinição de senha",
        type: "text",
        placeholder: "Redefinição de senha",
        defaultValue: "Redefinição de senha",
      },
      {
        name: "resetBody",
        label: "Corpo de redefinição de senha",
        type: "textarea",
        rows: 5,
        placeholder: "Use o código {{code}} para redefinir sua senha.",
        defaultValue: "Use o código {{code}} para redefinir sua senha.",
      },
      {
        name: "paymentSuccessSubject",
        label: "Assunto de pagamento aprovado",
        type: "text",
        placeholder: "Pagamento confirmado",
        defaultValue: "Pagamento confirmado",
      },
      {
        name: "paymentSuccessBody",
        label: "Corpo de pagamento aprovado",
        type: "textarea",
        rows: 5,
        placeholder: "Seu plano foi ativado com sucesso.",
        defaultValue: "Seu plano foi ativado com sucesso.",
      },
      {
        name: "paymentFailedSubject",
        label: "Assunto de pagamento recusado",
        type: "text",
        placeholder: "Não conseguimos processar seu pagamento",
        defaultValue: "Não conseguimos processar seu pagamento",
      },
      {
        name: "paymentFailedBody",
        label: "Corpo de pagamento recusado",
        type: "textarea",
        rows: 5,
        placeholder:
          "Revise seus dados de pagamento e tente novamente em {{checkoutUrl}}.",
        defaultValue:
          "Revise seus dados de pagamento e tente novamente em {{checkoutUrl}}.",
      },
      {
        name: "subscriptionRenewalSubject",
        label: "Assunto de renovação",
        type: "text",
        placeholder: "Sua assinatura foi renovada",
        defaultValue: "Sua assinatura foi renovada",
      },
      {
        name: "subscriptionRenewalBody",
        label: "Corpo de renovação",
        type: "textarea",
        rows: 5,
        placeholder:
          "Sua assinatura permanece ativa até {{currentPeriodEndsAt}}.",
        defaultValue:
          "Sua assinatura permanece ativa até {{currentPeriodEndsAt}}.",
      },
      {
        name: "subscriptionCanceledSubject",
        label: "Assunto de cancelamento",
        type: "text",
        placeholder: "Sua assinatura foi cancelada",
        defaultValue: "Sua assinatura foi cancelada",
      },
      {
        name: "subscriptionCanceledBody",
        label: "Corpo de cancelamento",
        type: "textarea",
        rows: 5,
        placeholder:
          "Se quiser voltar, seu acesso pode ser reativado a qualquer momento.",
        defaultValue:
          "Se quiser voltar, seu acesso pode ser reativado a qualquer momento.",
      },
      {
        name: "invoiceReadySubject",
        label: "Assunto de fatura",
        type: "text",
        placeholder: "Sua fatura está disponível",
        defaultValue: "Sua fatura está disponível",
      },
      {
        name: "invoiceReadyBody",
        label: "Corpo de fatura",
        type: "textarea",
        rows: 5,
        placeholder:
          "Acesse {{invoiceUrl}} para visualizar os detalhes do pagamento.",
        defaultValue:
          "Acesse {{invoiceUrl}} para visualizar os detalhes do pagamento.",
      },
      {
        name: "trialEndingSubject",
        label: "Assunto de teste expirando",
        type: "text",
        placeholder: "Seu período de teste está terminando",
        defaultValue: "Seu período de teste está terminando",
      },
      {
        name: "trialEndingBody",
        label: "Corpo de teste expirando",
        type: "textarea",
        rows: 5,
        placeholder:
          "Seu acesso de teste termina em {{trialEndsAt}}. Faça upgrade para manter tudo ativo.",
        defaultValue:
          "Seu acesso de teste termina em {{trialEndsAt}}. Faça upgrade para manter tudo ativo.",
      },
      {
        name: "accountDisabledSubject",
        label: "Assunto de conta desativada",
        type: "text",
        placeholder: "Sua conta foi desativada",
        defaultValue: "Sua conta foi desativada",
      },
      {
        name: "accountDisabledBody",
        label: "Corpo de conta desativada",
        type: "textarea",
        rows: 5,
        placeholder:
          "Sua conta foi desativada por um administrador. Se precisar, fale com o suporte.",
        defaultValue:
          "Sua conta foi desativada por um administrador. Se precisar, fale com o suporte.",
      },
      {
        name: "paymentSubject",
        label: "Assunto de pagamento",
        type: "text",
        placeholder: "Pagamento confirmado",
        defaultValue: "Pagamento confirmado",
      },
      {
        name: "paymentBody",
        label: "Corpo de pagamento",
        type: "textarea",
        rows: 5,
        placeholder: "Seu plano foi ativado com sucesso.",
        defaultValue: "Seu plano foi ativado com sucesso.",
      },
    ],
  },
  {
    key: "gtm",
    title: "Google Tag Manager",
    description:
      "Controle o container de métricas e acompanhamento do funil de vendas.",
    fields: [
      {
        name: "enabled",
        label: "Ativar GTM",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "containerId",
        label: "ID do container",
        type: "text",
        placeholder: "GTM-XXXXXXX",
        defaultValue: "",
      },
    ],
  },
  {
    key: "backups",
    title: "Backups",
    description:
      "Defina a política de cópias de segurança e retenção dos dados do sistema.",
    fields: [
      {
        name: "enabled",
        label: "Ativar backups automáticos",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "frequency",
        label: "Frequência",
        type: "select",
        defaultValue: "daily",
        options: [
          { label: "Diária", value: "daily" },
          { label: "Semanal", value: "weekly" },
          { label: "Mensal", value: "monthly" },
        ],
      },
      {
        name: "retentionDays",
        label: "Dias de retenção",
        type: "number",
        defaultValue: 30,
        placeholder: "30",
      },
      {
        name: "destination",
        label: "Destino do backup",
        type: "text",
        placeholder: "s3://miboard/backups",
        defaultValue: "",
      },
    ],
  },
  {
    key: "security",
    title: "Segurança e IP",
    description:
      "Bloqueie IPs suspeitos ou restrinja o painel administrativo a IPs permitidos. Use um IP por linha.",
    fields: [
      {
        name: "allowedIps",
        label: "IPs permitidos no painel administrativo",
        type: "textarea",
        rows: 5,
        placeholder: "Um IP por linha, deixe vazio para liberar o acesso atual",
        defaultValue: [],
      },
      {
        name: "blockedIps",
        label: "IPs bloqueados",
        type: "textarea",
        rows: 5,
        placeholder: "Um IP por linha. IPs bloqueados não acessam a API.",
        defaultValue: [],
      },
      {
        name: "rateLimitPerMinute",
        label: "Limite de requisições por minuto",
        type: "number",
        defaultValue: 120,
        placeholder: "120",
      },
      {
        name: "sessionTimeoutMinutes",
        label: "Tempo de sessão em minutos",
        type: "number",
        defaultValue: 480,
        placeholder: "480",
      },
      {
        name: "requireTwoFactor",
        label: "Exigir autenticação em dois fatores",
        type: "boolean",
        defaultValue: false,
      },
    ],
  },
];

export const adminSettingPagesByPath = {
  "/admin/gateway": "gateway",
  "/admin/email": "email",
  "/admin/email-templates": "email_templates",
  "/admin/gtm": "gtm",
  "/admin/backups": "backups",
  "/admin/security": "security",
};

export const adminSettingPageOrder = adminSettingPages.map((page, index) => ({
  key: page.key,
  title: page.title,
  description: page.description,
  sortOrder: index + 1,
  fields: page.fields,
}));

export const getAdminSettingPage = (key) =>
  adminSettingPages.find((page) => page.key === key) || null;
